import { get } from 'lodash';
import { type IHydrateWidgetInput } from '../../../../../hydrate/IHydrationContext.ts';
import { type IBaseWidget } from '../../../IBaseWidget.ts';
import { type IWidgetAdvancedOptionValue } from '../advanced-select-common/form/createAdvancedSelectValueSchema.ts';
import { type IAdvancedSelectWidget } from '../advanced-select-common/IAdvancedSelectWidget.ts';
import { renderAdvancedSelectedOptionLabel } from '../advanced-select-common/utils/renderAdvancedSelectedOptionLabel.ts';

/**
 * Funzione di idratazione del widget di selezione singola avanzata.
 * Restituisce la label dell'opzione selezionata. Le colonne RichText
 * mantengono l'HTML originale: il renderer del PDF lo interpreta.
 */
export function hydrateAdvancedSingleSelectWidget<
  W extends IBaseWidget &
    Pick<IAdvancedSelectWidget, 'labelFieldColumns' | 'columns'>,
>(input: IHydrateWidgetInput<W>) {
  const { context, path, widget } = input;

  const rawValue: IWidgetAdvancedOptionValue = get(context.values, path);
  if (!rawValue || typeof rawValue !== 'object') {
    return { value: undefined };
  }

  const label = renderAdvancedSelectedOptionLabel(
    rawValue,
    widget.labelFieldColumns,
    widget.columns,
    { keepRichTextHtml: true },
  );
  return { value: label || undefined };
}
